import axios from "@/plugins/axios"
import type { Pagination } from "@/types/common.type"
import type { Settlement, SettlementDetail, SettlementScheduled } from "@/types/settlement.type"

export interface ListRequest {
  page: string | null
  perPage: string | null
  completedAtGteq: string | null
  completedAtLteq: string | null
}

async function get(id: number): Promise<SettlementDetail> {
  const response = await axios.get<SettlementDetail>(`/settlements/${id}`)
  return response.data
}

async function list(request: ListRequest): Promise<Pagination<Settlement>> {
  const resposne = await axios.get<Pagination<Settlement>>("/settlements", {
    params: request,
  })
  return resposne.data
}

async function scheduled(): Promise<SettlementScheduled> {
  const response = await axios.get<SettlementScheduled>("/settlements/scheduled")
  return response.data
}

const settlementService = {
  get,
  list,
  scheduled,
}

export default settlementService
